import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Brain } from 'lucide-react';

const Header = () => {
  const marineBlue = '#1e5f74'; // Dark marine blue color
  const marineBlueDark = '#164a5a'; // Even darker for hover states
  const lightBlue = '#5fb3d4'; // Lighter blue for logo
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    // Check if user is logged in and get role
    const checkLoginStatus = () => {
      const token = localStorage.getItem('access_token');
      const userStr = localStorage.getItem('user');
      if (token && userStr) {
        const user = JSON.parse(userStr);
        setIsLoggedIn(true);
        setUserRole(user.role);
      } else {
        setIsLoggedIn(false);
        setUserRole('');
      }
    };

    // Check initially
    checkLoginStatus();

    // Add event listener for storage changes
    window.addEventListener('storage', checkLoginStatus);

    return () => {
      window.removeEventListener('storage', checkLoginStatus);
    };
  }, []);

  const handleDashboardClick = () => {
    switch (userRole) {
      case 'patient':
        navigate('/dashboard');
        break;
      case 'nurse':
        navigate('/nurse/dashboard');
        break;
      case 'psychiatrist':
        navigate('/psychiatrist/dashboard');
        break;
      case 'admin':
        navigate('/admin/dashboard');
        break;
      default:
        navigate('/login');
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-none bg-white backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto flex h-16 items-center px-4">
        {/* Logo */}
        <div className="flex items-center space-x-2 cursor-pointer" onClick={() => navigate('/')}>
          <Brain className="h-8 w-8" style={{color: lightBlue}} />
          <span className="text-2xl font-bold">
            <span style={{color: lightBlue}}>ADHD</span>
            <span style={{color: marineBlue}}>RapidCare</span>
          </span>
        </div>

        {/* Navigation Links - Centered */}
        <div className="flex-1 flex justify-center">
          <nav className="hidden md:flex space-x-8">
            <button 
              className="text-[#1e5f74] transition-colors hover:text-[#164a5a]" 
              onClick={() => navigate('/about-adhd')}
            >
              About ADHD
            </button>
            <button 
              className="text-[#1e5f74] transition-colors hover:text-[#164a5a]" 
              onClick={() => navigate('/care-plan')}
            >
              Care Plan
            </button>
            <button 
              className="text-[#1e5f74] transition-colors hover:text-[#164a5a]" 
              onClick={() => navigate('/medications')}
            >
              Medications
            </button>
          </nav>
        </div>

        {/* Right-aligned buttons */}
        <div className="flex items-center space-x-4 ml-auto">
          {isLoggedIn ? (
            <button
              style={{ background: 'linear-gradient(135deg, #2e86ab, #48cae4)' }}
              className="hover:opacity-90 text-white px-6 py-2 rounded text-sm font-medium transition-opacity"
              onClick={handleDashboardClick}
            >
              Dashboard
            </button>
          ) : (
            <>
              <button
                style={{ background: 'linear-gradient(135deg, #2e86ab, #48cae4)' }}
                className="hover:opacity-90 text-white px-4 py-1.5 rounded text-sm font-medium transition-opacity"
                onClick={() => navigate('/care-plan')}
              >
                Make a Booking
              </button>
              
              <button
                style={{ background: 'linear-gradient(135deg, #2e86ab, #48cae4)' }}
                className="hover:opacity-90 text-white px-4 py-1.5 rounded text-sm font-medium transition-opacity"
                onClick={() => navigate('/login')}
              >
                Login/Join
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
